import { gql } from "@apollo/client";
import {
  IBenefit,
  BenefitCategory,
  BenefitNature,
  BenefitResource,
} from "types/Benefit.type";

export interface ICreateBenefitInput {
  name: string;
  description?: string;
  type: string;
  category: BenefitCategory;
  nature: BenefitNature;
  countries: string[];
  detail?: string;
  externalUrl?: string;
  resources?: BenefitResource[];
  otherTypeDescription?: string;
  imageUrl?: string;
  hasValidity: boolean;
  startDate?: Date;
  endDate?: Date;
  requiresApproval?: boolean;
  requiresEvidence?: boolean;
  hasCapacityLimit?: boolean;
  capacityLimit?: number;
  isActive: boolean;
  isFeatured?: boolean;
}

export interface ICreateBenefitResponse {
  createBenefit: IBenefit;
}

export interface IUpdateBenefitInput extends ICreateBenefitInput {
  id: string;
}

export interface IUpdateBenefitResponse {
  updateBenefit: IBenefit;
}

export interface IDeleteBenefitResponse {
  deleteBenefit: boolean;
}

const CREATE_BENEFIT = gql`
  mutation CreateBenefit($input: CreateBenefitInput!) {
    createBenefit(input: $input) {
      id
      name
      description
      type
      category
      nature
      countries
      detail
      externalUrl
      resources {
        id
        title
        url
        type
        fileName
        mimeType
      }
      otherTypeDescription
      imageUrl
      hasValidity
      startDate
      endDate
      requiresApproval
      hasCapacityLimit
      capacityLimit
      isActive
      isFeatured
      createdAt
      updatedAt
    }
  }
`;

const UPDATE_BENEFIT = gql`
  mutation UpdateBenefit($id: String!, $input: UpdateBenefitInput!) {
    updateBenefit(id: $id, input: $input) {
      id
      name
      description
      type
      category
      nature
      countries
      detail
      externalUrl
      resources {
        id
        title
        url
        type
        fileName
        mimeType
      }
      otherTypeDescription
      imageUrl
      hasValidity
      startDate
      endDate
      requiresApproval
      hasCapacityLimit
      capacityLimit
      isActive
      isFeatured
      createdAt
      updatedAt
    }
  }
`;

const DELETE_BENEFIT_BY_ID = gql`
  mutation DeleteBenefit($id: String!) {
    deleteBenefit(id: $id)
  }
`;

export default {
  CREATE_BENEFIT,
  UPDATE_BENEFIT,
  DELETE_BENEFIT_BY_ID
};
